import { useEffect, useState } from "react";
import { useGame } from "../state/store";

/** Server epoch ms, re-rendering every `intervalMs` (only while a deadline is being watched). */
export function useServerNow(active = true, intervalMs = 250): number {
  const offset = useGame((s) => s.offsetMs);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [active, intervalMs]);
  return now + offset;
}

/** Milliseconds left until a server deadline (0 when passed, null when there is no deadline). */
export function useRemaining(deadlineMs: number | null | undefined): number | null {
  const now = useServerNow(deadlineMs != null);
  if (deadlineMs == null) return null;
  return Math.max(0, deadlineMs - now);
}
